<template lang="pug">
  div
    Create(:createDialog="createDialog" @close="close" @createdAdImage="createdAdImage" :createByDefaultValue="createByDefaultValue")
    Edit(:editDialog="editDialog" @close="closeEdit" @updatedAdImage="updatedAdImage" :adImage="adImage")
    
    v-card.mt-2
      v-toolbar.elevation-0(height="45" color="gray")
        v-toolbar-title
          h1.subheading {{ $t('pageHeader.ads') }}
        v-btn(color='teal', dark, small, absolute, bottom, right, fab @click="add") 
          v-icon add
        
      v-card-title
        v-flex(xs12 md5)
          v-text-field(v-model='search', append-icon='search', label='Search', single-line, hide-details)
        v-spacer
        v-btn(color='info' v-if="showUpdate" @click="updateChange") Update
      v-data-table(:headers='headers' item-key="id" :items='adImages' :search="search" :loading='loading' :pagination.sync='pagination')
        template(slot='items' slot-scope='props')
          tr.pointer
            td.pa-2
              img(:src="props.item.ClickImage.url" width='150' height="80" )
            td.text-xs-left {{ props.item.ClickImage.companyName }}
            td.text-xs-left {{ props.item.ClickImage.ClickImageDetails.length }}
            td 
              v-switch(v-model="props.item.ClickImage.isActive" @change="change(props.item)")
            td.justify-end.layout.px-0
              v-menu(bottom, left offset-y)
                v-btn(slot='activator', icon)
                  v-icon more_vert
                v-list.menu-button
                  v-list-tile(@click='edit(props.item)')
                    v-list-tile-title {{ $t('buttons.edit') }}
                  //- v-list-tile(@click='removeAdImage(props.item)')
                  //-   v-list-tile-title {{ $t('buttons.delete') }}

        v-alert(slot='no-results', :value='true', color='error', icon='warning')
          | Your search for "{{ search }}" found no results.
</template>

<script>
import adImageService from "../../service.js"
const Create = () => import('./Create')
const Edit = () => import('./Edit')
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      showUpdate: false,
      createDialog: false,
      adImage: null,
      createByDefaultValue: null,
      editDialog: false,
      headers: [
        {
          text: this.$t("labels.image"),
          value: "url",
          sortable: true,
        },
        {
          text: this.$t("labels.name"),
          value: "companyName",
          sortable: true
        },
        {
          text: this.$t("labels.clickCount"),
          value: "contactEmail",
          sortable: true
        },
        {
          text: this.$t("labels.active"),
          value: "isActive",
          sortable: true
        },
        {
          text: "",
          value: "action",
          sortable: false
        }
      ],
      search: null,
      adImages: [],
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: "id",
        descending: true
      }
    }
  },
  async created() {
    await this.getStoreAdList()
  },
  components: {
    Create,
    Edit
  },
  computed: {
    ...mapGetters('location', ['service'])
  },
  methods: {
    updateChange() {
      let count = 0
      this.adImages.map(row => {
        if (row.ClickImage.isActive) count += 1
      })
      if (count > 1) {
        this.$swal('Active Image', `You can't active more then 1 image`, 'error')
        // this.getStoreAdList()
      } else {
        let data = []
        this.adImages.map(row => {
          data.push({
            isActive: row.ClickImage.isActive,
            id: row.ClickImage.id
          }) 
        })
        return adImageService.resetCommercial({image: data})
        .then(response => {
          this.showUpdate = false
          this.$swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).fire({
            type: 'success',
            title: 'Ad Updated!'
          })
          return response
        })
        
      }
    },
    change(data) {
      this.showUpdate = true
    },
    removeAdImage(adImage) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then((result) => {
        if (result.value) {
          this.$Progress.start()
          return adImageService.delete(adImage.id).then((response) => {
            if (response.data) {
              this.$swal('Deleted!', 'AdImage has been deleted.', 'success')
              this.$Progress.finish()
              this.getAllListAds()
            }
          }).catch((error) => {
            this.$swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000
            }).fire({
              type: 'error',
              title: err.data.message
            })
            this.$Progress.fail()
          })
        }
      })
    },
    add() {
      this.createDialog = true
    },
    close() {
      this.createDialog = false
    },
    closeEdit() {
      this.editDialog = false
    },
    createdAdImage() {
      this.close()
      this.getStoreAdList()
    },
    updatedAdImage() {
      this.closeEdit()
      this.getStoreAdList()
    },
    edit(data) {
      this.adImage = data
      this.editDialog = true
    },
    updated() {
      this.editDialog = false
      this.getStoreAdList()
    },
    resetList() {
    },
    reloadData() {
      this.loading = true
      return adImageService.getAll().then(response => {
        this.adImages = response.data
        this.loading = false
        return response
      })
    },
    getStoreAdList() {
      this.loading = true
      adImageService.getStoreAdList(this.service.commercial.storeID)
      .then(response => {
        this.setByDefaultData(response.data)
        this.adImages = response.data
        this.loading = false
      })
    },
    setByDefaultData(storeList) {
      storeList.forEach((value, index) =>{
        if (parseInt(storeList.length)-1 == index) {
          this.createByDefaultValue = value
        }
      })
    }
  }
}
</script>
